import Base from "./base";
import QueryList from "./lists";
export default {
  Base,
  QueryList,
};
